export default "__VITE_ASSET__DsUZ6YIF__"